/**
 * アプリコンテンツの動的な変更を監視してフッターの位置を調整する
 */
(function() {
  'use strict';

  // フッター位置の再計算を行う関数
  function recalculateFooterPosition() {
    if (window.wetheme && window.wetheme.theme) {
      // テーマのFooterクラスのfixFooterToBottomメソッドを呼び出し
      const footerSections = window.wetheme.theme.registeredComponents.filter(
        component => component.constructor.name === 'Footer'
      );
      
      footerSections.forEach(footer => {
        if (typeof footer.fixFooterToBottom === 'function') {
          footer.fixFooterToBottom();
        }
      });
    }
  }

  // デバウンス関数
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // デバウンスされたフッター位置再計算
  const debouncedRecalculate = debounce(recalculateFooterPosition, 250);

  // MutationObserverでアプリコンテンツの変更を監視
  function observeAppContent() {
    const appSections = document.querySelectorAll('[data-wetheme-section-type="apps"]');
    const mainContent = document.getElementById('MainContent');
    
    if (!mainContent) return;

    // MutationObserverを設定
    const mutationObserver = new MutationObserver((mutations) => {
      let shouldRecalculate = false;
      
      mutations.forEach((mutation) => {
        // 子要素の追加・削除や属性の変更を検知
        if (mutation.type === 'childList' || 
            mutation.type === 'attributes' ||
            mutation.type === 'subtree') {
          shouldRecalculate = true;
        }
      });
      
      if (shouldRecalculate) {
        debouncedRecalculate();
      }
    });

    // メインコンテンツエリア全体を監視
    mutationObserver.observe(mainContent, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'height']
    });

    // アプリセクション個別も監視
    appSections.forEach(section => {
      mutationObserver.observe(section, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'height']
      });
    });
  }

  // ResizeObserverでコンテンツエリアのサイズ変更を監視
  function observeContentResize() {
    if (!window.ResizeObserver) return;

    const mainContent = document.getElementById('MainContent');
    const appSections = document.querySelectorAll('[data-wetheme-section-type="apps"]');
    
    if (!mainContent) return;

    const resizeObserver = new ResizeObserver((entries) => {
      debouncedRecalculate();
    });

    // メインコンテンツを監視
    resizeObserver.observe(mainContent);
    
    // アプリセクションも監視
    appSections.forEach(section => {
      resizeObserver.observe(section);
    });
  }

  // アプリのiframeロード完了を監視
  function observeIframeLoad() {
    const iframes = document.querySelectorAll('iframe[src*="apps.shopify.com"], iframe[src*="shopifycloud.com"]');
    
    iframes.forEach(iframe => {
      iframe.addEventListener('load', () => {
        // iframeロード後、少し遅延してフッター位置を再計算
        setTimeout(debouncedRecalculate, 500);
      });
    });
  }

  // 初期化関数
  function init() {
    // DOMが完全に読み込まれてから実行
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          observeAppContent();
          observeContentResize();
          observeIframeLoad();
          // 初期計算
          debouncedRecalculate();
        }, 100);
      });
    } else {
      setTimeout(() => {
        observeAppContent();
        observeContentResize();
        observeIframeLoad();
        // 初期計算
        debouncedRecalculate();
      }, 100);
    }
  }

  // ページ読み込み完了後にも再計算
  window.addEventListener('load', () => {
    setTimeout(debouncedRecalculate, 1000);
  });

  // Shopifyのセクションイベントにも対応
  document.addEventListener('shopify:section:load', debouncedRecalculate);
  document.addEventListener('shopify:section:unload', debouncedRecalculate);
  document.addEventListener('shopify:section:select', debouncedRecalculate);
  document.addEventListener('shopify:section:deselect', debouncedRecalculate);
  document.addEventListener('shopify:section:reorder', debouncedRecalculate);

  // 初期化実行
  init();
})();

